import { useLanguage } from '../contexts/LanguageContext';
import LocaleLink from './LocaleLink';

const LOGO_URL = 'https://quidory.com/media/quidory-logo.png';

const Footer = () => {
  const { t, language } = useLanguage();

  const productLinks = [
    { key: 'quidpulse', path: '/' },
    { key: 'quidanalyzer', path: '/' },
    { key: 'postPublisher', path: '/' },
    { key: 'videoPublisher', path: '/' },
  ];

  const companyLinks = [
    { key: 'about', path: '/about' },
    { key: 'features', path: '/features' },
    { key: 'pricing', path: '/pricing' },
    { key: 'contact', path: '/contact' },
  ];

  const legalLinks = [
    { key: 'privacy', path: '/privacy' },
    { key: 'terms', path: '/terms' },
    { key: 'cookie', path: '/cookie-policy' },
    { key: 'dataDeletion', path: '/data-deletion' },
    { key: 'support', path: '/support' },
  ];

  return (
    <footer className="border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-2">
            <LocaleLink to="/" className="flex items-center gap-2.5 mb-4 group w-fit">
              <img
                src={LOGO_URL}
                alt="Quidory"
                className="h-7 w-7 object-contain"
              />
              <span className="font-semibold text-foreground">
                {language === 'ar' ? 'كويدوري' : 'Quidory'}
              </span>
            </LocaleLink>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              {t('footer.tagline')}
            </p>
            <p className="mt-4 text-xs text-muted-foreground/70">
              support@quidory.com
            </p>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-foreground/60 mb-4">
              {t('footer.products')}
            </h3>
            <ul className="space-y-2.5">
              {productLinks.map(({ key, path }) => (
                <li key={key}>
                  <LocaleLink
                    to={path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200"
                  >
                    {t(`footer.links.${key}`)}
                  </LocaleLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-foreground/60 mb-4">
              {t('footer.company')}
            </h3>
            <ul className="space-y-2.5">
              {companyLinks.map(({ key, path }) => (
                <li key={key}>
                  <LocaleLink
                    to={path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200"
                  >
                    {t(`footer.links.${key}`)}
                  </LocaleLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-foreground/60 mb-4">
              {t('footer.legal')}
            </h3>
            <ul className="space-y-2.5">
              {legalLinks.map(({ key, path }) => (
                <li key={key}>
                  <LocaleLink
                    to={path}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-200"
                  >
                    {t(`footer.links.${key}`)}
                  </LocaleLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="text-xs text-muted-foreground/60 text-center sm:text-start">
            <p>{t('footer.copyright')}</p>
            <p className="mt-1 text-muted-foreground/50">{t('footer.legalEntity')}</p>
          </div>
          <div className="flex items-center gap-4">
            <LocaleLink to="/privacy" className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors">
              {t('footer.links.privacy')}
            </LocaleLink>
            <LocaleLink to="/terms" className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors">
              {t('footer.links.terms')}
            </LocaleLink>
            <button
              type="button"
              data-testid="footer-manage-cookies"
              onClick={() => {
                try { window.localStorage.removeItem('quidory.cookie-consent'); } catch {}
                window.location.reload();
              }}
              className="text-xs text-muted-foreground/60 hover:text-muted-foreground transition-colors"
            >
              {language === 'ar' ? 'إدارة الكوكيز' : 'Manage Cookies'}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
